// Medusa crée une option/variante "Default" pour les produits sans vraies variantes
// (et le plugin Dreamlove fait de même) : il n'y a alors rien à afficher ni à choisir.
const DEFAULT_LABELS = ['default', 'default option', 'default option value', 'default variant']

export const isDefaultOptionLabel = (label?: string | null): boolean =>
  !!label && DEFAULT_LABELS.includes(label.trim().toLowerCase())
